<p>member-detail works!</p>
